import { toast } from "react-toastify"

import { DELETE } from "modules/Core/api/REST"
import useAuthorizationHeader from "modules/Core/hooks/useAuthorizationHeader"
import { ActionButtons } from "pages/AdminPanelPage/modules/helpers/components/ActionButtons/ActionButtons.styled"
import EditButton from "pages/AdminPanelPage/modules/helpers/components/ui/EditButton/EditButton"
import TrashButton from "pages/AdminPanelPage/modules/helpers/components/ui/TrashButton/TrashButton"
import { Row } from "styles/Global.styled"
import { SliderType } from "types/common"
import { Button } from "ui/Button/Button.styled"
import { Input } from "ui/Input/Input.styled"
import { Table } from "ui/Table/Table.styled"

import useSliderList from "../hooks/useSliderList"

interface SliderListProps {
    setCurrentState: React.Dispatch<React.SetStateAction<string>>
    setSliderEdit: React.Dispatch<React.SetStateAction<SliderType | undefined>>
}

const SliderList: React.FC<SliderListProps> = ({ setCurrentState, setSliderEdit }) => {
    const headers = useAuthorizationHeader()
    const { sliderList, setSliderList } = useSliderList()

    const handleDelete = async (id: number) => {
        if (window.confirm("Вы действительно хотите удалить данную категорию?")) {
            try {
                const { data } = await DELETE("/api/admin/sliders/" + id, {}, { headers })

                if (data.ok === 1) {
                    toast.success("Категория успешно удалена!")
                    setSliderList((current) => current.filter((slider) => slider.id !== id))
                } else {
                    throw new Error(data.detail)
                }
            } catch (error) {
                toast.error("Произошла ошибка " + error)
            }
        }
    }

    const handleEdit = (slider: SliderType) => {
        setCurrentState("update")
        setSliderEdit(slider)
    }

    const handleCreate = () => {
        setCurrentState("create")
        setSliderEdit(undefined)
    }

    return (
        <>
            <Row justify="space-between">
                <div style={{ width: "300px" }}>
                    <Input placeholder="Начни вводить текст" />
                </div>
                <div>
                    <Button onClick={handleCreate} btnColor="black">
                        Добавить слайд
                    </Button>
                </div>
            </Row>
            <Table>
                <thead>
                    <tr>
                        <td>#</td>
                        <td>Название</td>
                        <td>Номер по счету</td>
                        <td>Действия</td>
                    </tr>
                </thead>
                <tbody>
                    {sliderList?.length > 0 &&
                        sliderList.map((slider: SliderType, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{slider.name}</td>
                                <td>{slider.order}</td>
                                <td>
                                    <ActionButtons>
                                        <EditButton onClick={() => handleEdit(slider)} />
                                        <TrashButton onClick={() => handleDelete(slider.id)} />
                                    </ActionButtons>
                                </td>
                            </tr>
                        ))}
                </tbody>
            </Table>
        </>
    )
}

export default SliderList
